import React, { useEffect } from 'react'
import CenterStage from '../Components/CenterStage/CenterStage'
import SectionHeader from '../Components/SectionHeader/SectionHeader'
import TextCaption from '../Components/TextCaption/TextCaption'
import ImageCard from '../Components/ImageCard/ImageCard'
import { Container, Row, Col, Button } from 'react-bootstrap';
import imgBrazilServicos_01 from '../assets/BrazilServicos/BrazilServicos_01.jpg';
import imgBrazilServicos_02 from '../assets/BrazilServicos/BrazilServicos_02..jpg';
import imgBrazilServicos_03 from '../assets/BrazilServicos/BrazilServicos_03..jpg';
import imgBrazilServicos from '../assets/BrazilServicos/BrazilServicos.jpg'

const BrazilServicos = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on component mount
  }, []);

  return (
    <div>
      <div>
        <CenterStage
          imageSrc={imgBrazilServicos}
          title={"THE HANSA-FLEX SERVICE RANGE"}
          paragraph={"HANSA-FLEX is your trusted partner for everything related to the planning, design, installation, maintenance, and optimization of your hydraulic systems. We also provide comprehensive procurement services, perform fluid analysis, and support you in the development of special components and prototypes. Our years of experience mean we know how to complete complex tasks in short timeframes."}
        />
      </div>

      <SectionHeader
        title={"COMPREHENSIVE HYDRAULIC SERVICES, ALL FROM THE SAME SUPPLIER"}
        paragraph={"Benefit from the support of experienced fluid specialists at HANSA-FLEX"} />
      <br />


      <Container>
        <Row>
          <Col sm={12} md={6} lg={4}>
            <ImageCard image={imgBrazilServicos_01} learnMoreLink={'/mobile-rapid-hydraulic-service'} title="Quick help in case of emergency" desc={"With around 200 service vehicles throughout Germany and 7 in Brazil, our Mobile Hydraulic Service is always there for you, available 24 hours a day, 7 days a week, 365 days a year to minimize your machine downtimes."} />
          </Col>
          <Col sm={12} md={6} lg={4}>
            <ImageCard image={imgBrazilServicos_02} learnMoreLink={'/repair-and-overhaul'} title="Experienced experts in everything related to hydraulic systems" desc={"HANSA-FLEX Industrial Service supports you in all your hydraulics-related tasks, including installation, maintenance, optimization and renewal of your machines and systems."} />
          </Col>
          <Col sm={12} md={6} lg={4}>
            <ImageCard image={imgBrazilServicos_03} learnMoreLink={'/preventative-maintainance'} title="Avoid dangerous situations through preventive maintenance" desc={"Hydraulic systems work incredibly hard. Regular maintenance ensures reliable, safe, and efficient operation of systems and machinery."} />
          </Col>
        </Row>
      </Container>
      <br /><br />
    </div>
  )
}

export default BrazilServicos